<template>
  <div class="md-layout">
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-blue">
        <h6 class="text-primary">Latest Tour Bookings</h6>
      </md-card-header>
      <md-card-content>
        <div class="booking-section">
          <template v-if="tourBookings.length">
            <BookingItem
              v-for="booking in tourBookings"
              :key="'tour-' + booking.id"
              :booking="booking"
            />
          </template>
          <div v-else class="empty-state text-center">
            <p>There are no recent tour bookings.</p>
          </div>
        </div>

        <div class="booking-section">
          <h6 class="text-primary">Latest Event Bookings</h6>
          <template v-if="eventBookings.length">
            <BookingItem
              v-for="booking in eventBookings"
              :key="'event-' + booking.id"
              :booking="booking"
            />
          </template>
          <div v-else class="empty-state text-center">
            <p>There are no recent event bookings.</p>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import bookingApi from "@/services/api/booking";
import BookingItem from "./BookingItem.vue";

export default {
  name: "WidgetNewBookings",

  components: { BookingItem },

  data() {
    return {
      bookings: []
    };
  },

  computed: {
    tourBookings() {
      return this.bookings.filter(b => b.type?.value === "tour").slice(0, 5);
    },
    eventBookings() {
      return this.bookings.filter(b => b.type?.value === "event").slice(0, 5);
    }
  },

  created() {
    bookingApi.getNewBookings().then(response => {
      this.bookings = response.data.bookings;
    });
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/md/_variables.scss";

h6 {
  margin: 0.5rem 0;
}

p {
  margin: 0;
}

.booking-section + .booking-section {
  margin-top: 1rem;
}
</style>
